/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Foot Pedal Settings" |
*
* @param {Options_Pedal_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_form_label = /** @type {((inputs?: Options_Pedal_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de pédale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fußpedaleinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni del pedale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки ножной педали")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes del pedal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("脚踏板设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フットペダルの設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फुट पेडल सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações do pedal")
	return /** @type {LocalizedString} */ ("Foot Pedal Settings")
});